<template>
  <div class="drawer-scroll">
    <div>
      <div class="drawer-header d-flex align-item-center">
      <span>Summary</span>
<!--      <div>-->
<!--        <Button type="danger" @click="" plain>Reject</Button>-->
<!--        <Button type="primary" @click="">Approve</Button>-->
<!--      </div>-->
    </div>
      <div class="ask-si-card">
        <div class="ask-si-header">
          <span><svgicon name="ai-wand" width="20" height="20" :original="true"/> Pando Ai Insights</span>
        </div>
        <div class="ask-si-content">
          <div class="text-left width-full">
            <P class="user-suggestion" v-html="summary.summary.recommendation"></P>
            <ul>
              <li class="mb-5 text-sm" v-if="summary.summary.data_comparison_validations">
                <svgicon :name="summary.summary.data_comparison_validations.status === 'positive' ? 'green-circle-tick' : 'warning'" width="12" height="12" :original="true" class="mr-5"/>
                {{ summary.summary.data_comparison_validations.message }}
              </li>
              <li class="mb-5 text-sm">
                <svgicon :name="summary.summary.lr_validations.status === 'positive' ? 'green-circle-tick' : 'warning'" width="12" height="12" :original="true" class="mr-5"/>
                {{ summary.summary.lr_validations.message }}
              </li>
              <li class="mb-5 text-sm">
                <svgicon :name="summary.summary.shortage_damage_validations.status === 'positive' ? 'green-circle-tick' : 'warning'" width="12" height="12" :original="true" class="mr-5"/>
                {{ summary.summary.shortage_damage_validations.message }}
              </li>
              <li class="mb-5 text-sm" v-if="summary.summary.signature_validations">
                <svgicon :name="summary.summary.signature_validations.status === 'positive' ? 'green-circle-tick' : 'warning'" width="12" height="12" :original="true" class="mr-5"/>
                {{ summary.summary.signature_validations.message }}
              </li>
            </ul>
          </div>
        </div>
        <div class="ask-si-bubble">
          <div class="pi-logo-container">
            <div class="ask-si-bubble-rings">
              <div class="ask-si-bubble-ring"></div>
              <div class="ask-si-bubble-ring"></div>
              <div class="ask-si-bubble-ring"></div>
              <div class="ask-si-bubble-ring"></div>
            </div>
            <svgicon name="Pi-Avatar" class="ask-si-bubble-center-icon svg-fill-none" :original="true"/>
            <svgicon name="ai-wand" class="ask-si-bubble-star-icon svg-fill-none" :original="true"/>
          </div>
        </div>
      </div>

      <!-- Per-LR Validation Sections (directly below AI insights) -->
      <div v-if="summary && summary.validation_comparison && summary.validation_comparison.lr_comparisons && summary.validation_comparison.lr_comparisons.length" class="lr-validation-wrapper">
        <Collapse v-model="expandedLrs" class="collapse-slider collapse-dark">
          <CollapseItem
            v-for="(lrComp, index) in summary.validation_comparison.lr_comparisons"
            :key="index"
            :name="index"
            :class="{'lr-has-mismatch': lrComp.overall_status === 'MISMATCH', 'lr-match': lrComp.overall_status === 'MATCH'}">
            <template slot="title">
              <span>{{ lrComp.lr_number }} ({{ lrComp.overall_status }})</span>
            </template>

            <!-- Mismatch Banner -->
            <div v-if="lrComp.mismatch_summary" class="lr-error-message">
              <i class="el-icon-warning"></i>
              <span>{{ lrComp.mismatch_summary }}</span>
            </div>

            <!-- Comparison Table -->
            <div class="preview-content">
              <table class="lr-comparison-table">
              <thead>
                <tr>
                  <th>FIELD</th>
                  <th>SYSTEM ENTRY</th>
                  <th>OCR EXTRACTED</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="lrComp.invoice_numbers" :class="getRowClass(lrComp.invoice_numbers.status)">
                  <td>Invoice Numbers</td>
                  <td>{{ formatFieldValue(lrComp.invoice_numbers.system) }}</td>
                  <td>{{ formatFieldValue(lrComp.invoice_numbers.ocr) }}</td>
                </tr>
                <tr v-if="lrComp.shortage" :class="getRowClass(lrComp.shortage.status)">
                  <td>Shortage</td>
                  <td>{{ lrComp.shortage.system }} units</td>
                  <td>{{ lrComp.shortage.ocr }} units</td>
                </tr>
                <tr v-if="lrComp.damage" :class="getRowClass(lrComp.damage.status)">
                  <td>Damage</td>
                  <td>{{ lrComp.damage.system }} units</td>
                  <td>{{ lrComp.damage.ocr }} units</td>
                </tr>
                <tr v-if="lrComp.carton_damage" :class="getRowClass(lrComp.carton_damage.status)">
                  <td>Carton Damage</td>
                  <td>{{ lrComp.carton_damage.system }} units</td>
                  <td>{{ lrComp.carton_damage.ocr }} units</td>
                </tr>
                <tr v-if="lrComp.receiving_date" :class="getRowClass(lrComp.receiving_date.status)">
                  <td>Receiving date</td>
                  <td>{{ formatDate(lrComp.receiving_date.system) }}</td>
                  <td>{{ formatDate(lrComp.receiving_date.ocr) }}</td>
                </tr>
                <tr v-if="lrComp.consignee_name" :class="getRowClass(lrComp.consignee_name.status)">
                  <td>Consignee Name</td>
                  <td>{{ lrComp.consignee_name.system || 'N/A' }}</td>
                  <td>{{ lrComp.consignee_name.ocr || 'N/A' }}</td>
                </tr>
              </tbody>
              </table>
            </div>
          </CollapseItem>
        </Collapse>
      </div>
    </div>
    <div ref="scrollTarget" class="p-15">
      <div class="clearfix">
        <div class="documents-title">uploaded documents</div>
        <div>
          <div :class="{'disableUpload': disableUpload}">
            <Upload
              action
              list-type="picture-card"
              :file-list="getAttachments"
              :limit="maxAllowed"
              :multiple="multiple"
              :auto-upload="false"
              :on-exceed="handleExceed"
              :on-change="addAttachment"
              :disabled="disableUpload"
              class="default-upload flex-reverse dark"
              :class="{'is-disabled':disableUpload}">
              <i class="el-icon-plus" @click="$emit('setGA','Add Attachment Icon')"></i>
              <div class="el-upload-list__item-slot" slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="setIcon(file)" alt=""/>
                <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="previewAttachment(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <Popconfirm title="Are you sure to delete the attachment?" @confirm="removeAttachment(file)">
                <span slot="reference"
                      v-if="!disableUpload && !disableDelete && !isLRRejectEnable"
                      class="el-upload-list__item-delete">
                  <i class="el-icon-delete"></i>
                </span>
              </Popconfirm>
            </span>
                <div v-if="file.name" class="filenametag">{{ file.name }}</div>
              </div>
            </Upload>
            <a class="download-file"/>
            <Dialog :visible.sync="dialogVisible"
                    width="80%"
                    :append-to-body="true"
                    :close-on-click-modal="false"
                    :fullscreen="true"
                    :show-close="false"
                    custom-class="preview-popup">
              <div class="preview-header text-right">
              <span class="actions" style="margin-right: 20px;">
                <svgicon
                  name="rotate-left"
                  class="pointer"
                  width="20"
                  height="20"
                  @click="rotateLeft"/>
                <svgicon
                  name="rotate-right"
                  class="pointer ml-20"
                  width="20"
                  height="20"
                  @click="rotateRight"/>
                <svgicon
                  name="cancelnocolor"
                  class="pointer ml-20"
                  width="20"
                  height="20"
                  @click="dialogVisible = false"/>
              </span>
              </div>
              <div class="preview-body">
                <Dialog :visible.sync="dialogVisible"
                        :style="`transform: rotate(${rotation}deg); transition: transform 0.5s ease-in-out`">
                  <img width="100%" :src="selectedImageSrc" alt=""/>
                </Dialog>
              </div>
            </Dialog>
          </div>
          <div class="flex-container align-top">
            <div class="flex-item text-right ml-auto mt-40 mb-10" v-if="hasAttachments && selectedAttachmentIndex !== -1">
              <span class="text-white">
                <svgicon
                  name="icon-expand-xl"
                  class="pointer"
                  width="20"
                  height="20"
                  @click="handlePictureCardPreview(selectedAttachment);$emit('setGA','Expand Icon')"/>
                <svgicon
                  name="icon-download-xl"
                  class="pointer ml-20"
                  @click="handleDownload(selectedAttachment);$emit('setGA','Download Icon')"
                  width="20"
                  height="20"/>
              </span>
            </div>
          </div>
        </div>
        <div class="preview-upload" v-if="hasAttachments">
          <img :src="selectedImageSrc" alt=""/>
        </div>
      </div>
    </div>
    <div class="summary-preview" v-if="viewLrSummary && showSummary">
      <Collapse class="collapse-slider collapse-dark">
        <CollapseItem title="SUMMARY">
          <div class="preview-content">
            <ul class="mt-0">
              <li>
                <vue-markdown :source="cleanUpMarkdown(selectedAttachment.summary.document_summary.extracted_data_markdown || selectedAttachment.summary.document_summary.summary)"/>
              </li>
            </ul>
          </div>
        </CollapseItem>
      </Collapse>
      <!--      <div class="preview-title d-flex align-item-center justify-content-between" @click="">-->
      <!--        <span class="accord-tab">SUMMARY</span>-->
      <!--        <span class="accord-sign"></span>-->
      <!--      </div>-->
      <!--      <div class="preview-content">-->
      <!--        <ul>-->
      <!--          <li v-for="(item, index) in getAttachments" v-if="item.summary && item.summary.document_summary" :key="index">-->
      <!--            &lt;!&ndash;            <h4>Document {{ index + 1}} Summary</h4>&ndash;&gt;-->
      <!--            <vue-markdown :source="cleanUpMarkdown(item.summary.document_summary.summary)"/>-->
      <!--            &lt;!&ndash;            <p>{{item.summary.document_summary.summary}}</p></li>&ndash;&gt;-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--      </div>-->
    </div>
  </div>
</template>
<script type="text/javascript">
import UploadMixin from "@common/mixins/UploadMixin";
import VueMarkdown from 'vue-markdown'
import { isEmpty } from 'lodash'

export default {
  components: {
    VueMarkdown,
  },
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    disableUpload: {
      type: Boolean,
      default: false
    },
    lrNumberDetails: {
      type: Array,
      default: () => []
    },
    maxAllowed: {
      type: Number,
      default: 5,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    orderDetails: {
      type: Object,
      default: {},
    },
    viewLrSummary: {
      type: Boolean,
      default: false,
    },
    summary: {
      type: Object,
    }
  },
  data() {
    return {
      comment: '',
      reasonList: [],
      lrRejectedReason: {
        custom: '',
        data: '',
      },
      value: '',
      expandedLrs: [], // Open LR collapse items
      isPopoverVisible: false,
      previewOnselect: true,
      activeName: 0,
    };
  },
  mixins: [UploadMixin],
  created() {
    this.selectedAttachmentIndex = -1;
    this.getLRRejectionReason();
  },
  mounted() {
  },
  watch: {
    selectedAttachmentIndex(newVal) {
      if (newVal !== -1) {
        this.$nextTick(() => {
          const target = this.$refs.scrollTarget;
          const container = document.querySelector('.drawer-scroll');
          if (container && target) {
            container.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
          }
        });
      }
    }
  },
  computed: {
    showSummary() {
      console.log('-----1',this.selectedAttachment)
      return this.selectedAttachmentIndex !== -1 && this.selectedAttachment && !isEmpty(this.selectedAttachment.summary);
    },
    getAttachments() {
      return this.attachments;
    },
    hasAttachments() {
      return this.attachments && this.attachments.length;
    },
    isLRRejectEnable() {
      return (this.$hasPermission('lr_attchment_rejection') && this.$hasFeature('lr_attchment_rejection'))
    },
    isRejectDisable() {
      return (this.lrRejectedReason.data || this.lrRejectedReason.custom)
    },
  },
  methods: {
    cleanUpMarkdown(rawMarkdown) {
      if (typeof rawMarkdown !== 'string') {
        return ''
      }
      return rawMarkdown
        .replace(/(['"])\s*\+\s*\1/g, '')
        .replace(/\\n/g, '\n')
        .replace(/\\r/g, '\r')
        .replace(/\\t/g, '\t')
        .trim()
    },
    async getLRRejectionReason() {
      let depotId;
      if (this.orderDetails && [1, 2].includes(this.orderDetails.movement)) { // TODO: Use constants
        depotId = this.orderDetails.sources && this.orderDetails.sources[0]
          && this.orderDetails.sources[0].location_id;
      } else {
        depotId = this.orderDetails.destinations && this.orderDetails.destinations[0]
          && this.orderDetails.destinations[0].location_id;
      }
      const payload = {
        type: 'LR_ATTACHMENT_REJECTION',
        movement: this.orderDetails && this.orderDetails.movement,
        depot_id: depotId,
      };
      const result = await this.$store.dispatch('settings/getReasonSettings', payload);
      if (result && result.data && result.data.length) {
        const configReasons = result.data.map(item => ({
          key: item,
          value: item,
        }));
        this.reasonList = [
          ...configReasons,
          {
            value: 'OTHERS',
            key: 'OTHERS',
          },
        ];
      } else {
        this.reasonList = [
          {
            value: 'OTHERS',
            key: 'OTHERS',
          },
        ];
      }
    },
    async rejectAttachments() {
      const file = this.attachments[this.selectedAttachmentIndex];
      let reason = this.lrRejectedReason.data === 'OTHERS' ? this.lrRejectedReason.custom : this.lrRejectedReason.data;
      const rejectedData = {
        attachmentId: file.id,
        lrRejectedReason: reason
      }
      this.$emit('rejectAttachments', rejectedData);
      this.selectedAttachmentIndex = 0;
      this.closePopover();
    },
    removeAttachment(file) {
      this.$emit("removeAttachments", file);
      this.selectedAttachmentIndex = 0;
    },
    togglePopover() {
      this.isPopoverVisible = !this.isPopoverVisible;
    },
    closePopover() {
      this.isPopoverVisible = false;
      this.lrRejectedReason = {
        data: '',
        custom: ''
      }
    },
    formatFieldName(key) {
      return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    },
    formatFieldValue(value) {
      if (Array.isArray(value)) {
        return value.join(', ') || 'N/A';
      }
      if (value === null || value === undefined || value === '') {
        return 'N/A';
      }
      if (typeof value === 'object' && value.constructor.name === 'Date') {
        return new Date(value).toLocaleDateString();
      }
      return String(value);
    },
    getRowClass(status) {
      if (status === 'MATCH') return 'row-match';
      if (status === 'MISMATCH' || status === 'NOT_VALIDATED') return 'row-mismatch';
      if (status === 'PARTIAL_MATCH') return 'row-partial';
      return '';
    },
    getValidationStatusType(status) {
      if (status === 'MATCH') return 'success';
      if (status === 'MISMATCH') return 'danger';
      if (status === 'PARTIAL_MATCH') return 'warning';
      return 'info';
    },
    getLrCollapseClass(lrComp) {
      if (lrComp.overall_status === 'MISMATCH') return 'lr-mismatch';
      if (lrComp.overall_status === 'PARTIAL_MATCH') return 'lr-partial';
      return 'lr-match';
    },
    formatDate(dateValue) {
      if (!dateValue) return 'N/A';
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return 'Invalid Date';
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    },
  },
};
</script>
<style lang="scss" scoped>
.drawer-scroll {
  padding: 0;
  width: 100%;
}

.el-collapse.collapse-slider .el-collapse-item__header {
  background-color: #343441 !important;
}

.preview {
  &-title {
    padding: 13px 0 14px 10px;
    display: block;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    background: #343441;
    margin-top: 15px;
    text-transform: capitalize !important;

    span {
      display: block;
      font-weight: 600;
      font-size: 13px;
      letter-spacing: 0.7px;

      &.text-white {
        font-size: 12px !important;
        text-transform: capitalize !important;
      }
    }

    .accord-tab {
      color: #747486;
    }

    .accord-sign {
      margin-right: 20px;
      color: #747486;

      &::before {
        content: '+';
        transition: transform 0.2s ease;
      }
    }

    &.active {
      &::before {
        content: '-';
      }
    }
  }

  &-content {
    padding: 1px 10px;
    border-radius: 10px;

    h4 {
      color: #dfdede;
      text-transform: uppercase;
      font-weight: 800;
      letter-spacing: 0.3px;
      font-size: 10px;
      margin-top: 20px;
    }

    p {
      line-height: 16px;
      font-size: 11px;
      //color: #d2d4dd;
    }

    li {
      border-bottom: 0.5px solid #646468;
    }
  }

}

.ask-si-card {
  margin: 15px;
  position: relative;
  background: linear-gradient(270deg, #2A2B2F 5.52%, #24242F 94.48%);
  color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  z-index: 1;
}

.ask-si-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px 5px;
  font-weight: bold;
  font-size: 16px;
}

.ask-si-header .pointer {
  margin-left: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.ask-si-header span {
  flex: 1;
  color: #FFE01B;
  font-size: 14px;
}

.ask-si-content {
  padding: 5px 16px 10px;

  .user-suggestion {
    color: #fff;
    font-size: 14px;
    margin: 0;
  }

  ul{
    padding-top: 10px;
    margin-top: 0;
    li {
      color: #D4DBF4;
      display: flex;
      align-items: center;

      svg{
        min-height: 14px !important;
        min-width: 14px !important;
      }
    }
  }
}

/* Shimmer effect */
.shimmer-line {
  height: 10px;
  margin-bottom: 8px;
  border-radius: 6px;
  background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.1) 25%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.1) 75%
  );
  background-size: 200% 100%;
  width: 40%;
}

.shimmer-line.short {
  width: 60%;
}

.ask-si-bubble {
  position: absolute;
  bottom: 0;
  right: -8px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2001;
  cursor: pointer;
}

.ask-si-bubble-rings {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  @for $i from 1 through 6 {
    .ask-si-bubble-ring:nth-child(#{$i}) {
      width: 45px + ($i - 1) * 15px;
      height: 45px + ($i - 1) * 15px;
      background-color: rgba(255, 225, 27, (0.4 - ($i - 1) * 0.1));
      animation-delay: ($i - 1) * 0.4s;
    }
  }
}

.ask-si-bubble-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-70%, -50%);
  border-radius: 50%;
  animation: opacity-wave 3s infinite ease-in-out;
}

@keyframes opacity-wave {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.8;
  }
}

.ask-si-bubble-center-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-59%, -45%);
  z-index: 10;
  width: 45px;
  height: 45px;
}

.svg-fill-none {
  fill: none !important;
}

.ask-si-bubble-star-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  transform: translate(-4px, -32px);
  width: 15px;
  height: 13px;
}

.collapse-slider.collapse-dark {
  .el-collapse-item__header.is-active {
    color: #D5DAF4;
  }
}

.lr-error-message {
  background: #2e2e3b;
  border: 1px solid rgba(231, 76, 60, 0.4);
  border-radius: 8px;
  padding: 10px 10px;
  display: flex;
  align-items: center;
  gap: 10px;

  i {
    color: #E74C3C;
    font-size: 16px;
    flex-shrink: 0;
    margin-top: 2px;
  }

  span {
    color: #FFB3B3;
    font-size: 13px;
    line-height: 1.5;
  }
}

.lr-comparison-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #2e2e3b;

  thead th {
    color: #9CA3AF;
    text-align: left;
    padding: 6px;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.5px;
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  tbody td {
    padding: 6px;
    color: #D5DAF4;
    font-size: 13px;
    background-color: transparent;
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .row-mismatch td {
    background-color: rgba(231, 76, 60, 0.15);
    color: #FFB3B3;
  }
}

.preview-content {
  h1, h2, h3, h4 {
    color: #fff;
    font-size: 13px;
    margin-bottom: 5px;
  }

  ul {
    color: #fff;
    margin-bottom: 15px;

    li {
      color: #d0d5d7 !important;
      font-size: 12px !important;
      line-height: 20px;

      &::marker {
        content: '• ';
        color: black;
        font-weight: bold;
      }
    }

    p {
      color: #d5daf4 !important;
      font-size: 12px !important;
      line-height: 20px;
    }
  }
}

.documents-title {
  color: #D4DBF4;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.lr-validation-wrapper {
  margin-top: 15px;

  .el-collapse-item {
    margin-bottom: 10px;
  }

  .el-collapse.collapse-slider .el-collapse-item__content {
    padding: 0 !important;
  }

  .preview-content {
    padding: 10px 0;
  }
}

.lr-has-mismatch.el-collapse-item .el-collapse-item__header {
  border-left: 4px solid #E74C3C !important;
}

.lr-has-mismatch.el-collapse-item .el-collapse-item__header:after {
  background: linear-gradient(90deg, rgba(231, 76, 60, 0.3) 0%, transparent 100%) !important;
}

.validation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.validation-status-badge {
  font-size: 12px;
  font-weight: bold;
}

.validation-table {
  width: 100%;
  border-collapse: collapse;
  color: #D5DAF4;
  font-size: 12px;

  th {
    background-color: rgba(255, 255, 255, 0.05);
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    font-weight: 600;
  }

  td {
    padding: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  .row-match {
    background-color: rgba(103, 194, 58, 0.1);
  }

  .row-mismatch {
    background-color: rgba(245, 108, 108, 0.1);
  }

  .row-partial {
    background-color: rgba(230, 162, 60, 0.1);
  }

  .field-message {
    font-size: 11px;
    color: #A0A5B9;
    margin-top: 4px;
  }
}
</style>
